// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import CompanySubPage from '../../components/Company/CompanySubPage/CompanySubPage';
import ViewMembersReport from '../../components/Company/ViewMembersReport/ViewMembersReport';
// Type imports:
import { ICompanyReportViewModel } from '../../types/CompanyTypes';

const ViewMemberReport: React.FC<ICompanyReportViewModel> = ({
    id,
    eventId,
    isAuthenticated,
    isSubscriber
}) => {
    return (
        <Entrypoint>
            <CompanySubPage 
                id={id} 
                title='Fyrirtæki'
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
                noAd
                component={
                    <ViewMembersReport
                        id={id ?? ''}
                        eventId={eventId ?? ''}
                        isSubscriber={isSubscriber}
                    />
                }
                showRecentReports
            />
        </Entrypoint>
    );
}

export default ViewMemberReport;